import { MultiSelect, type MultiSelectProps } from "@design-system/shadcn";
import React from "react";

import { useFilters } from "../filters-provider";

import { FilterBarField } from "./filter-bar-field";

interface FilterBarMultiSelectProps extends Omit<
  MultiSelectProps,
  "value" | "onValueChange" | "variant"
> {
  name: string;
  tooltip?: string;
}

function FilterBarMultiSelect({
  name,
  tooltip,
  ...props
}: FilterBarMultiSelectProps) {
  const { getValue, setValue } = useFilters();
  const value = getValue(name);

  return (
    <FilterBarField name={name} tooltip={tooltip}>
      <MultiSelect
        {...props}
        variant="pill"
        value={Array.isArray(value) ? value : []}
        onValueChange={(next) => setValue(name, next)}
      />
    </FilterBarField>
  );
}

export { FilterBarMultiSelect };
export type { FilterBarMultiSelectProps };
